import {isNil} from 'ramda';

import {CustomerRequestBody} from '@dms/api/customer';

import {getContactRequestBody} from './getContactRequestBody';

/**
 * Turns the values of the customer edit forms into the request body; the founding person is
 * cleaned like a contact. `emailFormIndexes` keeps the form row of each sent e-mail.
 */
export const getCustomerRequestBody = (values: CustomerRequestBody) => {
  if (isNil(values.foundingPerson)) {
    return {customerRequestBody: values, emailFormIndexes: []};
  }

  const {personRequestBody, emailFormIndexes} = getContactRequestBody(values.foundingPerson);

  return {customerRequestBody: {...values, foundingPerson: personRequestBody}, emailFormIndexes};
};
